// extracted by mini-css-extract-plugin
export default {"card":"card-module--card--1e03f"};